import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";

function AbonosMaquilerosFaltantesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_HABILITACION_CORTES = process.env.REACT_APP_URL_HABILITACION_CORTES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [text, setText] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [procesosSalida, setProcesosSalida] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorNombre, setSelectedProveedorNombre] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [ano, setAno] = useState(date.getFullYear());
  const [semana, setSemana] = useState(moment(date).week());
  const [concepto, setConcepto] = useState("Abono");

  const [selectedBanco, setSelectedBanco] = useState("62dec0c3b05cd629f4ff7b44");
  const [bancos, setBancos] = useState([]);

  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);
  // const [importeAplicar, setImporteAplicar] = useState(0);
  // const [saldoAplicar, setSaldoAplicar] = useState(0);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const formasPago = ["Faltante"];
  const [inputFields, setInputFields] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
axios
      .get(`${URL_PROVEEDORES}Maquileros`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let proveedoresActivos = response.data.filter(
          (p) => p.is_active === "Si"
        );
        setProveedores(proveedoresActivos);

        // Inicializamos inputFields vacío con proveedores x formasPago
        const inicial = [];
        proveedoresActivos.forEach((prov) => {
          formasPago.forEach((fp) => {
            inicial.push({
              proveedorId: prov._id,
              formaPago: fp,
              importe: 0,
            });
          });
        });
        setInputFields(inicial);
      })
      .catch((err) => {
        console.log(err);
      });

     axios
  .get(`${URL_PROCESOS_SALIDA}Faltantes`, {
    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
  })
  .then(async (response) => {
    const allProcesosSalida = response.data;

    // Base para la tabla
    const dataTabla = allProcesosSalida.map((a) => ({
      id: a?._id, // procesosSalidaId
      OP: a?.cortes?.[0]?.ordenesCorte?.[0]?.numeroOP || "",
      Modelo: `${a?.articulos?.[0]?.codigo || ""} ${a?.articulos?.[0]?.nombre || ""}`,
      Maquilero: a?.proveedores?.[0]?.nombre_comercial || "",
      MaquileroId: a?.proveedores?.[0]?._id || "",
      Faltantes: (a?.totalPiezas || 0) - (a?.recibido || 0),
      MontoPrenda: 0,
      MontoMaterial: 0,
      TotalFila: 0,          // <- no lo usamos; calculamos al vuelo
    }));

    setProcesosSalida(dataTabla);

for (const row of dataTabla) {
  try {
    const { data: docs } = await axios.get(
      `${URL_HABILITACION_CORTES}/byProcesos/${row.id}`,
      { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
    );
    // Buscar el doc preferido
    let docPreferido = null;
    for (const d of docs) {
      if (
        !docPreferido ||
        ((d.saldo ?? 0) > 0 && (docPreferido.saldo ?? 0) <= 0) ||
        (new Date(d.updatedAt || d.fecha) >
          new Date(docPreferido.updatedAt || docPreferido.fecha))
      ) {
        docPreferido = d;
      }
    }

    // Actualizar la fila con el saldo
    setProcesosSalida((prev) =>
      prev.map((r) =>
        r.id === row.id
  ? { ...r, MontoMaterial: Number((docPreferido?.saldo ?? 0).toFixed(2)) }
  : r
      )
    );
  } catch (err) {
    console.log(err);
  }
}
  })



  .catch(console.log);



    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });
  
  }, []);

function handleChangeInputImporte(value, field, id) {
  setProcesosSalida(prev =>
    prev.map(r => r.id === id ? { ...r, [field]: Number(value || 0) } : r)
  );
}



  // Calcular total de todos los pagos
  const totalGeneral = inputFields.reduce((acc, curr) => acc + (curr.importe || 0), 0);


  // function ActualizaTotales() {
  //   let TEfe = inputFields.map((c) => parseFloat(c.importe));
  //   let TE = TEfe.reduce((t, total, index) => t + total, 0);

  //   setTotal(TE);

  //   // setSaldoAplicar(importeAplicar - TE);
  // }
console.log("hola", procesosSalida)
const calcTotalFila = (row) => {
  const falt = Number(row.Faltantes || 0);
  const mp   = Number(row.MontoPrenda || 0);
  const mm   = Number(row.MontoMaterial || 0);
  return falt * mp + (mp > 0 ? mm : 0);
};

async function savePago() {
  if (selectedBanco === "") {
    Swal.fire({ icon: "error", title: "Oops...", text: "Debes completar todo el formulario" });
    return;
  }

  // Recalcular TotalFila aquí, no confiar en el render
  const filas = (procesosSalida || [])
    .map((row) => ({
      ...row,
      TotalFila: calcTotalFila(row),
    }))
    .filter((row) => Number(row.TotalFila) > 0);

  if (filas.length === 0) {
    Swal.fire({ icon: "info", title: "Nada que hacer", text: "Todos los importes están en 0" });
    return;
  }

  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const elegirDocPreferido = (docs = []) => {
    let best = null;
    for (const d of docs) {
      if (
        !best ||
        ((d?.saldo ?? 0) > 0 && (best?.saldo ?? 0) <= 0) ||
        new Date(d?.updatedAt || d?.fecha || 0) > new Date(best?.updatedAt || best?.fecha || 0)
      ) best = d;
    }
    return best;
  };

  try {
    toggleProgreso();

    await Promise.all(
      filas.map(async (a) => {
        // 1) Crear abono con el total calculado
        await axios.post(
          URL_ABONOS_PROVEEDORES,
          {
            fecha,
            importe: Number(a.TotalFila),
            proveedores: a.MaquileroId,
            bancos: selectedBanco,
            observaciones: a.OP,
            codigoAgrupado,
            editado: "No",
            concepto,
            formaPago: "Faltante",
            semana,
            ano,
          },
          { headers }
        );

        // 2) Habilitaciones -> saldo = 0
        const procesoId = a.procesosSalidaId || a.id; // usa a.id si no traes procesosSalidaId
        if (procesoId) {
          const { data: docs } = await axios.get(
            `${URL_HABILITACION_CORTES}/byProcesos/${procesoId}`,
            { headers }
          );
          const docPreferido = elegirDocPreferido(docs);
          if (docPreferido?._id) {
            await axios.patch(
              `${URL_HABILITACION_CORTES}/${docPreferido._id}`,
              { saldo: 0 },
              { headers }
            );
          }

          // 3) Cerrar proceso
          await axios.patch(
            `${URL_PROCESOS_SALIDA}/${procesoId}`,
            { status: "Cerrado" },
            { headers }
          );
        }
      })
    );

    Swal.fire("Éxito", "Abonos creados y procesos cerrados", "success");
    setTimeout(() => window.location.reload(), 1000);
  } catch (error) {
    console.error(error);
    Swal.fire({ icon: "error", title: "Oops...", text: "Algo salió mal" });
  }
}




  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  // helpers
const pad2 = (n) => String(n).padStart(2, "0");
const toWeekInputValue = (y, w) => `${y}-W${pad2(w)}`;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_adminCxP ? (
        <div className="card container col-sm-11">
          <h3 align="center">Captura un Pago por Faltante</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                {/* <Col md={2}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col> */}
                <Col md={2}>
                  <Label className="mr-sm-2">Semana</Label>
                  <Input
                    type="week"
                    value={toWeekInputValue(ano, semana)} // ej: "2025-W35"
                    onChange={(e) => {
                      // e.g. "2025-W35"
                      const [yStr, wStr] = e.target.value.split("-W");
                      const isoYear = parseInt(yStr, 10);
                      const week = parseInt(wStr, 10);

                      // Viernes de esa semana ISO, en UTC para evitar desfases
                      const friday = moment
                        .utc()
                        .isoWeekYear(isoYear)
                        .isoWeek(week)
                        .isoWeekday(5) // 1=lunes ... 5=viernes
                        .format("YYYY-MM-DD");

                      setAno(isoYear);
                      setSemana(week);
                      setFecha(friday); // "YYYY-MM-DD"
                    }}
                  />
                </Col>

                {/*    <Col md={3}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedProveedor) => {
                      if (selectedProveedor) {
                        setValue(selectedProveedor);
                        setSelectedProveedor(selectedProveedor._id);
                        setSelectedProveedorNombre(
                          selectedProveedor.nombre_comercial
                        );
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>

                <Col md={2}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => {
                      setConcepto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Concepto</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>


                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      setSelectedBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col> 

                <Col md={5}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)}
                    </Badge>
                  </h4>
                </Col>*/}
              </Row>
              <br />
              {/* <Row>
                <Col md={1}>
                  <Label>Importe Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={importeAplicar}
                    className={`form-control`}
                    onValueChange={(value, name) => IA(value)}
                  />
                </Col>
                <Col md={1}>
                  <Label>Saldo Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={saldoAplicar}
                    className={`form-control`}
                    disabled
                  />
                </Col>
              </Row>
              <br /> */}
              <Row>
                {/* Tabla Cargos */}
                <br />
                <br />
<Table striped borderless>
<thead>
  <tr>
    <th>OP</th>
    <th>Modelo</th>
    <th>Maquilero</th>
    <th>Faltantes</th>
    <th>Monto x Prenda</th>
    <th>Monto x Material</th>
    <th>Total</th>
  </tr>
</thead>
<tbody>
  {procesosSalida.map((row) => {
    // Calcular total dinámico con monto por prenda
    const TotalFila =
  (row.Faltantes || 0) * (row.MontoPrenda || 0) +
  (row.MontoPrenda > 0 ? (row.MontoMaterial || 0) : 0);

    return (
      <tr key={row.id}>
        <td>{row.OP}</td>
        <td>{row.Modelo}</td>
        <td>{row.Maquilero}</td>
        <td>{row.Faltantes}</td>
        <td>
          <CurrencyInput
  intlConfig={{ locale: "en-US", currency: "USD" }}
  prefix="$"
  decimalsLimit={2}
  value={row.MontoPrenda}
  className="form-control"
  onValueChange={(value) =>
    handleChangeInputImporte(value, "MontoPrenda", row.id)
  }
/>



        </td>
        <td>
<CurrencyInput
  intlConfig={{ locale: "en-US", currency: "USD" }}
  prefix="$"
  decimalsLimit={2}
  value={row.MontoMaterial}
  className="form-control"
  disabled
/>
        </td>
        <td>
          <CurrencyInput
            intlConfig={{ locale: "en-US", currency: "USD" }}
            prefix="$"
            decimalsLimit={2}
            value={TotalFila}
            className="form-control"
            disabled
          />
        </td>
      </tr>
    );
  })}

  <tr>
    <td colSpan={6} className="negrita" align="center">
      Total General
    </td>
    <td className="negrita" colSpan={2}>
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(
        procesosSalida.reduce(
          (acc, curr) => acc + (curr.Faltantes || 0) * (curr.MontoPrenda || 0),
          0
        )
      )}
    </td>
  </tr>
</tbody>


  <br />
</Table>


                {/* Termina tabla cargos */}
              </Row>
            </FormGroup>
            <br />
            <Row>
              <Button className="btn btn-success" onClick={savePago}>
                {" "}
                Registrar
              </Button>

              <Button
                href="/ListadoAbonosMaquileros"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default AbonosMaquilerosFaltantesCreate;
